<template>
  <b-container class="d-flex align-items-stretch">
    <b-nav vertical class="mx-5 my-5">
      <!-- <b-nav-item id="my-nav-dropdown">最新文献</b-nav-item> -->

      <b-form-group id="my-nav-dropdown" label="1.选择文献更新日期:">
        <b-form-select v-model="selected" :options="dates"></b-form-select>
        <!-- <b-form-radio
          v-model="selected"
          name="some-radios"
          v-for="item in dates"
          v-bind:key="item"
          :value="item"
          >{{ item }}</b-form-radio
        > -->
      </b-form-group>
      <b-form-group id="my-nav-dropdown" label="2.选择文献所在领域:">
        <li class="nav-item">
          <a class="nav-link" style="cursor: pointer;" @click="show_battery()">电池文献</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" style="cursor: pointer;" @click="show_superconduct()">超导文献</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" style="cursor: pointer;" @click="show_topological()">拓扑文献</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" style="cursor: pointer;" @click="show_quantumcomputating()">量子计算</a>
        </li>

        <!-- <b-nav-item-dropdown
        id="my-nav-dropdown"
        text="电池文献"
        toggle-class="nav-link-custom"
        right
      > -->
        <!-- <b-dropdown-item @click="show_battery()">确定是</b-dropdown-item>
        <b-dropdown-item @click="show_possible_battery()"
          >可能是</b-dropdown-item
        > -->
        <!-- </b-nav-item-dropdown> -->
        <!-- <b-nav-item-dropdown
        id="my-nav-dropdown"
        text="超导文献"
        toggle-class="nav-link-custom"
        right
      > -->
        <!-- <b-dropdown-item @click="show_superconduct()">确定是</b-dropdown-item>
        <b-dropdown-item @click="show_possile_superconduct()"
          >可能是</b-dropdown-item
        > -->
        <!-- </b-nav-item-dropdown>
      <b-nav-item-dropdown
        id="my-nav-dropdown"
        text="拓扑文献"
        toggle-class="nav-link-custom"
        right
      > -->
        <!-- <b-dropdown-item @click="show_topological()">确定是</b-dropdown-item>
        <b-dropdown-item @click="show_possible_topological()">可能是</b-dropdown-item> -->
        <!-- </b-nav-item-dropdown>
      <b-nav-item-dropdown
        id="my-nav-dropdown"
        text="量子计算"
        toggle-class="nav-link-custom"
        right
      > -->
        <!-- <b-dropdown-item @click="show_quantumcomputating()">确定是</b-dropdown-item>
        <b-dropdown-item @click="show_possible_quantumcomputating()">可能是</b-dropdown-item> -->
        <!-- </b-nav-item-dropdown> -->

        <!-- <b-nav-item-dropdown
        id="my-nav-dropdown"
        text="AI in 材料"
        toggle-class="nav-link-custom"
        right
      >
        <b-dropdown-item @click="show_AI4MatSci()">确定是</b-dropdown-item>
        <b-dropdown-item @click="show_possible_AI4MatSci()">可能是</b-dropdown-item>
      </b-nav-item-dropdown> -->
      </b-form-group>
    </b-nav>
  </b-container>
</template>

<script>
import { eventBus } from "../../main";
export default {
  data() {
    return {
      // contents: "",
      selected: "",
      dates: [],
      docName: "battery",
      variant: "dark",
      variants: [
        "transparent",
        "white",
        "light",
        "dark",
        "primary",
        "secondary",
        "success",
        "danger",
        "warning",
        "info",
      ],
    };
  },
  watch: {
    $route(to, from) {
      // console.log(this.docName)
      // 刷新参数放到这里面去触发就可以刷新相同界面了
      this.fetchData();
    },
  },
  mounted() {
    this.$http.get("/fetchdates/").then((res) => {
      console.log(res.data);
      this.dates = res.data;
      this.selected = this.dates[0];
      eventBus.$emit("selected", this.selected);
      if (this.$route.params.id && this.$route.params.id != "newest") {
        //  console.log("docname is" + this.$route.params.id);

        this.selected = this.$route.params.id.split("-")[0];
        this.docName = this.$route.params.id.split("-")[1];

        // let url =
        //   "/static/literaturehtml/" +
        //   this.selected +
        //   "/" +
        //   this.docName +
        //   ".html";
        // // console.log(url)
        //   this.$http.get(url).then((res) => {
        //   this.contents = res.data;
        // });
      }
    });
  },
  methods: {
    fetchData() {
      // console.log("enter....");
      if (this.$route.params.id) {
        if (this.$route.params.id != "newest") {
          this.selected = this.$route.params.id.split("-")[0];
          this.docName = this.$route.params.id;
        } else {
          // console.log(this.selected)
          this.selected = this.dates[0];
          this.docName = "battery";
        }
        // console.log(this.$route.params.id);

        // console.log("docname is" + this.docName);
        // let url =
        //   "/static/literaturehtml/" +
        //   this.selected +
        //   "-" +
        //   this.docName +
        //   ".html";
        // // console.log(url);
        // this.$http.get(url).then((res) => {
        //   this.contents = res.data;
        // });
      }
    },
    show_battery() {
      this.docName = "battery";
      // this.$router.push({
      //   path: "/literature_trends",
      //   query: { id: this.docName }
      // });
      this.$router.push(`/literature_trends/${this.selected}-${this.docName}`);
      // console.log(this.$route.query);
    },
    show_possible_battery() {
      this.docName = "battery_uncertain";
      this.$router.push(`/literature_trends/${this.selected}-${this.docName}`);
      // console.log('this is '+ this.$route.params.id)
    },
    show_superconduct() {
      this.docName = "superconductor";
      this.$router.push(`/literature_trends/${this.selected}-${this.docName}`);
    },
    show_possile_superconduct() {
      this.docName = "superconductor_uncertain";
      // this.$router.push('/literature_trends/superconducting_uncertain')
      this.$router.push(`/literature_trends/${this.selected}-${this.docName}`);
      // console.log('this is '+ this.$route.params.id)
    },
    show_topological() {
      this.docName = "topological";
      this.$router.push(`/literature_trends/${this.selected}-${this.docName}`);
    },
    show_possible_topological() {
      this.docName = "topological_uncertain";
      this.$router.push(`/literature_trends/${this.selected}-${this.docName}`);
    },
    show_quantumcomputating() {
      this.docName = "quantumcomputating";
      this.$router.push(`/literature_trends/${this.selected}-${this.docName}`);
    },
    show_possible_quantumcomputating() {
      this.docName = "quantumcomputating_uncertain";
      this.$router.push(`/literature_trends/${this.selected}-${this.docName}`);
    },
    show_AI4MatSci() {
      this.docName = "AI4MatSci";
      this.$router.push(`/literature_trends/${this.selected}-${this.docName}`);
    },
    show_possible_AI4MatSci() {
      this.docName = "AI4MatSci_uncertain";
      this.$router.push(`/literature_trends/${this.selected}-${this.docName}`);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.jumbotron {
  background-size: cover;
}
.center {
  /* text-align:center */
}
h4,
.h4 {
  font-size: 1rem !important;
}
#my-nav-dropdown {
  font-size: 1.5rem;
}

</style>
